import axios from 'axios';

export default class Api {
  static post(url, data = {}, config = {}) {
    // eslint-disable-next-line
    if (!IS_PROD) {
      config.params = data;
      return axios.get(url, config);
    }

    return axios.post(url, data, config);
  }

  static get(url, data = {}) {
    return axios.get(url, {
      params: data,
    });
  }
}



// WEBPACK FOOTER //
// ./base/script/api.js